export const initialState = {
  price: 1000,
  enabled: false,
  selected: false,
  selectionLocked: false,
  monthName: null,
  product: null,
  isFetching: true,
}

export const setData = (state, payload) => ({
  ...payload, isFetching: false,
})

export const setFetching = (state, payload) => ({
  ...state, isFetching: payload,
})

export const setSelected = (state, payload) => ({
  ...state, selected: payload,
})

export const reset = () => initialState
